import React from "react";
import {DriverDeliveriesProvider} from "./DriverDeliveriesContext.jsx";
import {TableDateSearchProvider} from "../../admin/Context/TableDateSearchContext.jsx";
import {ResponsiveView} from "../../components/index.jsx";
import {Devices} from "../../components/ResponsiveView/consts.js";
import {DriverDeliveriesMobile} from "./DriverDeliveries.mobile.jsx";
import {DriverDeliveries} from "./DriverDeliveries.jsx";

export const DriverDeliveriesWrapper = ({history}) => {
    return (
        <TableDateSearchProvider localStorageKey="driverDeliveriesSearchDate">
            <DriverDeliveriesProvider>
                <ResponsiveView devices={[Devices.desktop]}>
                    <DriverDeliveries history={history} />
                </ResponsiveView>

                <ResponsiveView devices={[Devices.mobile]}>
                    <DriverDeliveriesMobile />
                </ResponsiveView>
            </DriverDeliveriesProvider>
        </TableDateSearchProvider>
    );
};
